import types from '../mutation-types';
import ContactBookingsAPI from '../../api/contactBookings';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getAllBookingsByContact: _state => contactId => {
    const records = _state.records[contactId] || [];
    return records.sort((r1, r2) => r2.id - r1.id);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAllBookingsByContactId: _state => contactId => {
    return _state.records[contactId] || [];
  },
};

export const actions = {
  async get({ commit }, { contactId }) {
    commit(types.SET_CONTACT_BOOKINGS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ContactBookingsAPI.get(contactId);
      commit(types.SET_CONTACT_BOOKINGS, { contactId, data });
    } catch (error) {
      // ignore
    } finally {
      commit(types.SET_CONTACT_BOOKINGS_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, { contactId, bookingData }) {
    commit(types.SET_CONTACT_BOOKINGS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await ContactBookingsAPI.create(contactId, bookingData);
      commit(types.ADD_CONTACT_BOOKING, { contactId, data });
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_BOOKINGS_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { contactId, bookingId, bookingData }) {
    commit(types.SET_CONTACT_BOOKINGS_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await ContactBookingsAPI.update(
        contactId,
        bookingId,
        bookingData
      );
      commit(types.UPDATE_CONTACT_BOOKING, { contactId, data });
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_BOOKINGS_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, { bookingId, contactId }) {
    commit(types.SET_CONTACT_BOOKINGS_UI_FLAG, { isDeleting: true });
    try {
      await ContactBookingsAPI.delete(contactId, bookingId);
      commit(types.DELETE_CONTACT_BOOKING, { contactId, bookingId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_BOOKINGS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_BOOKINGS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  [types.SET_CONTACT_BOOKINGS]($state, { data, contactId }) {
    $state.records = { ...$state.records, [contactId]: data };
  },

  [types.ADD_CONTACT_BOOKING]($state, { data, contactId }) {
    const contactBookings = $state.records[contactId] || [];
    $state.records[contactId] = [...contactBookings, data];
  },

  [types.UPDATE_CONTACT_BOOKING]($state, { data, contactId }) {
    const contactBookings = $state.records[contactId] || [];
    $state.records[contactId] = contactBookings.map(booking =>
      booking.id === data.id ? data : booking
    );
  },

  [types.DELETE_CONTACT_BOOKING]($state, { bookingId, contactId }) {
    const contactBookings = $state.records[contactId] || [];
    const filtered = contactBookings.filter(b => b.id !== bookingId);
    $state.records[contactId] = [...filtered];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
